import { authHeader } from '../_helpers';
import axios from 'axios';

export const userService = {
  login,
  forgotPassword,
  changePassword,
  logout,
  getAll,
  deleteUser,
  getAllUsersAndTrainings,
  setPaymentStatus,
  setTraining
};

async function login(email, password) {
  return axios.post(process.env.ROOT_API + '/api/v1/users/login', {
    email: email,
    password: password
  });
}
async function forgotPassword(email) {
  return axios.post(`${process.env.ROOT_API}/api/v1/tokens`, {
    email: email
  });
}

async function changePassword(token, password) {
  return axios.put(`${process.env.ROOT_API}/api/v1/tokens`, {
    token: token,
    password: password
  });
}

function logout() {
  return localStorage.removeItem('user');
}

function getAll() {
  this.$http
    .get(process.env.ROOT_API + '/api/v1/users', authHeader())
    .then(function (response) {
      return response;
    })
    .catch(function (err) {
      console.log(err);
    });
}

async function deleteUser(id) {
  return axios.delete(`${process.env.ROOT_API}/api/v1/users/${id}`, {
    headers: authHeader()
  });
}

function getAllUsersAndTrainings() {
  return axios.get(`${process.env.ROOT_API}/api/v1/users`, {
    headers: authHeader()
  });
}

async function setPaymentStatus(id, paid) {
  return axios.put(
    `${process.env.ROOT_API}/api/v1/users/${id}/payments`,
    {
      paid: paid
    },
    {
      headers: authHeader()
    }
  );
}

async function setTraining(userId, trainingId) {
  return axios.put(
    `${process.env.ROOT_API}/api/v1/trainings/${
      parseInt(trainingId) + 1
    }/users/${userId}`,
    {},
    {
      headers: authHeader()
    }
  );
}



// WEBPACK FOOTER //
// ./src/_services/user.js